export default {
  header: {
    home: "Home",
    products: "Products",
    product: "Products",
    about: "About",
    service: "Service",
    contact: "Contact Us",
    buyOnline: "Buy Online"
  },
  common: {
    loading: "Loading...",
    error: "Failed to load, please try again later",
    noData: "No data available",
    retry: "Retry",
    more: "Learn More",
    lastPage: "Last Page",
    backList: "Back to List",
    loadFail: "Load failed",
  },
  hero: {
    title1: "SHENYI Makes Your Way",
    title2: "",
    subtitle: "",
    cta: "Learn More",
    carImageAlt: "Pilatnet Tire Display"
  },
  about: {
    title: "Brand Story",
    subtitle: "Pilatnet Tire is a strategic brand under Nexen Tire Group",
    content: "SHENYI is a tire brand dedicated to using advanced technology to solve driving challenges in the new era of daily travel. The R&D team always adheres to the brand vision of \"creating a better travel experience for users\". Through optimized material formulations, innovative tread patterns and structural designs, we continuously push technological boundaries and refine products to help users enhance travel quality, ensuring good handling and driving experience while maintaining safety even in harsh weather and complex road conditions.",
    more: "Learn More",
    brandName: "SHENYI",
    brandSub: "Mid-to-High-End Brand from China",
    milestone: "Brand Milestones",
    achievements: "Honors and Achievements",
    honor: "Enterprise Honor"
  },
  products: {
    title: "Featured Tires",
    viewMore: "View More",
    buyNow: "Buy Now",
    priceFrom: "Daily rate from",
    series: {
      all: "All Series"
    },
    product1: {
      name: "UltraContact UX7",
      desc: "Good driving and quiet driving"
    },
    product2: {
      name: "UltraContact UX7",
      desc: "Comfortable control and quiet ride"
    },
    product3: {
      name: "UltraContact UX7",
      desc: "Energy saving and precise turning"
    },
    noSelling: "No selling points",
    noId: "No product ID specified",
    loadFail: "Failed to get product details",
    loadFailRetry: "Failed to get product details, please try again later",
    noDesc: "No product description",
    static1: {
      name: "Pilot UHP",
      subtitle: "ThinkSpeed UHP",
      desc: "Ultra-high performance, sporty tire",
      longDesc: "PILOTNET-UHP tires are designed and structured to improve handling and cornering stability. The asymmetric tread design provides excellent handling performance and enhances driving ability on wet and slippery roads."
    },
    static2: {
      name: "Pilot HP",
      subtitle: "ThinkSpeed HP",
      desc: "Comfortable and sporty tire",
      longDesc: "PILOTNET-HP uses new rubber technology to improve tire wear and better heat dissipation. The combination of different tread grooves provides excellent drainage, outstanding stability and steering, allowing you to drive with confidence!"
    }
  },
  technology: {
    title: "Our Innovative Technology",
    subtitle: "Shenyi is a reputable tire company that offers a wide range of useful services for every taste.",
    tech1: {
      title: "Easy to handle and stable",
      desc: "Using deep neural network methods, combined with the GCC3 adaptive equation group continuously trained by German AI, the driving is smoother and more natural, and the control is more intuitive"
    },
    tech2: {
      title: "Wetlands are safe and strong",
      desc: "Using deep neural network methods, combined with the GCC3 adaptive equation group continuously trained by German AI, the driving is smoother and more natural, and the control is more powerful"
    },
    tech3: {
      title: "More comfortable and safer",
      desc: "Using deep neural network methods, combined with the GCC3 adaptive equation group continuously trained by German AI, the driving is smoother and more natural, and the control is more comfortable"
    },
    tech4: {
      title: "High Mileage & Wear Resistance",
      desc: "Advanced materials and optimized structure design greatly improve tire wear resistance and service life, ensuring safe and reliable long-distance driving."
    }
  },
  footer: {
    products: "Products",
    about: "About Us",
    interact: "Interact With Us",
    company: "Company Profile",
    history: "Development History",
    wechat: "WeChat",
    tiktok: "TikTok",
    contact: "Customer Service Hotline",
    needHelp: "Need help with tires? Please call"
  },
  blog: {
    title: "Media Center",
    noData: "No media content",
    loadFailRetry: "Failed to get media information, please try again later"
  },
  bannerSlider: {
    fixedVideoTitle: "Bull GTRcomfort",
    fixedVideoSubtitle: "Comfortable and durable tire, produced by Zhongce Rubber"
  }
} 